import styled from 'styled-components'

export const buttonVariants = {
  primary: {
    backgroundColor: '#0f82c5',
    color: 'white',
    '&:visited, &:hover, &:active, &:focus': {
      textDecoration: 'none',
      color: 'white',
      backgroundColor: '#268eca',
    },
  },
  secondary: {
    backgroundColor: '#f1f2f7',
    color: '#434449',
    '&:visited, &:hover, &:active, &:focus': {
      textDecoration: 'none',
      backgroundColor: '#f1f2f7',
    },
  },
  tertiary: {
    backgroundColor: '#07bb9c',
    color: 'white',
    '&:visited, &:hover, &:active, &:focus': {
      textDecoration: 'none',
      color: 'white',
    },
  },
  danger: {
    backgroundColor: 'red',
    color: 'white',
    '&:visited, &:hover, &:active, &:focus': {
      textDecoration: 'none',
      color: 'white',
    },
  },
  ghost: {
    backgroundColor: 'transparent',
    color: 'black',
    '&:visited, &:hover, &:active, &:focus': {
      textDecoration: 'none',
      color: '#4f4f4f',
      backgroundColor: 'transparent',
    },
  },
}

type TBButtonProps = {
  variant?: keyof typeof buttonVariants
  disabled?: boolean
}

export const TBButton = styled.button<TBButtonProps>`
  padding: 10px 15px;
  border: 0;
  line-height: 1;
  border-radius: 3px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  i {
    font-size: 16px;
    margin-left: 1rem;
  }
  // Apply a variant style if the button isn't disabled
  ${(props) => !props.disabled && buttonVariants[props.variant ?? 'primary']}
`
